
import {computed, defineComponent, onMounted, PropType, reactive, ref, watch} from "vue";
import Dropdown from 'primevue/dropdown';
import {DbLinkLocatorDetails, DocumentLocator, MasterDataColumn} from "@dex/squeeze-client-ts";
import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import {useI18n} from "vue-i18n";
import {useToast} from "primevue/usetoast";
import {showDropdownOverlay} from "@/util/StylesHelper";

export default defineComponent({
	name: "DBLinkedDataForm",
	components: {
		Dropdown,
	},
	props: {
		DBLinkedData: {
			type: Object as PropType<DbLinkLocatorDetails>,
			required: true,
		},
		allLocators: {
			type: Array as PropType<DocumentLocator[]>,
			required: true,
		},
		masterDataColumns: {
			type: Array as PropType<MasterDataColumn[]>,
			required: true,
		},
		showErrorMessage: {
			type: Boolean,
		},
	},
	emits: ['update'],
	setup(props, {emit}) {
		const {t} = useI18n();
		const toast = useToast();

		/** Show loading? */
		const loading = ref(false);

		/** List of stopUnique booleans */
		const stopUnique = computed(() => {
			return [
				{
					id: true,
					name: t('Squeeze.General.Yes'),
				},
				{
					id: false,
					name: t('Squeeze.General.No'),
				},
			]
		});

		/** Current Object of all input-fields */
		const value = reactive<DbLinkLocatorDetails>({
			sourceLocatorId: 0,
			dbcolumn: 0,
			stopIfUnique: true,
		});

		/** Determines the required rules for validation */
		const rules = {
			sourceLocatorId: { required },
			dbcolumn: { required },
			stopIfUnique: { required },
		}

		/** Use Vuelidate */
		const v$ = useVuelidate(rules, value);

		onMounted(async () => {
			Object.assign(value, props.DBLinkedData);

			// Emit Validated-Values onMounted. Otherwise there can be validation-errors when editing multiple entries
			await v$.value.$validate();
			emit("update", value, v$.value.$invalid);
		});

		/** Watch prop at set value object, because props are not allowed to be mutated */
		watch(props.DBLinkedData, () => {
			Object.assign(value, props.DBLinkedData);
		})

		/** Triggered on change of any field */
		const update = () => {
			emit("update", value, v$.value.$invalid);
		}

		return {
			t,
			toast,
			loading,
			stopUnique,
			value,
			props,
			v$,
			Dropdown,
			update,
			showDropdownOverlay,
		}
	},
});

